import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import helper from "../../helpers/query";
import format from "../../helpers/format";
import { history } from "../../redux/store";
import Pagination from "../../components/Pagination";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import Filter from "../../components/Filter/Filter";
import { Table } from "react-bootstrap";
import OrderApi from "../../api/orderAPI";
import qs from "query-string";


dayjs.extend(relativeTime);


// Define filters similar to FileList
const filters = [
  {
    type: "text",
    name: "s",
    defaultValue: "",
    placeholder: "Search...",
  },
  {
    type: "select",
    name: "status",
    options: [
      { title: "Select status", value: "" },
      { title: "Pending", value: "pending" },
      { title: "Approved", value: "approved" },
      { title: "Rejected", value: "rejected" },
      { title: "Completed", value: "completed" },
      { title: "Cancelled", value: "cancelled" },
    ],
    defaultValue: "",
  },
  {
    type: "select",
    name: "orderType",
    options: [
      { title: "Select type", value: "" },
      { title: "Single", value: "single" },
      { title: "Subscription", value: "subscription" },
    ],
    defaultValue: "",
  },
];

const defaultFilter = filters.reduce(
  (obj, cur) => ({ ...obj, [cur.name]: cur.defaultValue }),
  {}
);

const initialQuery = {
  ...defaultFilter,
  page: 1,
  pageSize: 20,
};

const OrderList = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [pageSize, setPageSize] = useState(initialQuery.pageSize); //@TODO : should correct this
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1); //helper.useQueryString("page");
  const [query, setQuery] = useState(initialQuery);
  const [selectedOrders, setSelectedOrders] = useState([]); // Store selected order IDs

  // Handle checkbox change for a single order
  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prevSelected) =>
      prevSelected.includes(orderId)
        ? prevSelected.filter((id) => id !== orderId)
        : [...prevSelected, orderId]
    );
  };

  // Handle select all checkbox
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOrders(orders.map((item) => item._id));
    } else {
      setSelectedOrders([]);
    }
  };


  const loadPage = (params) => {
    // Always include all filter fields
    const fullParams = {
      status: params.status ?? query.status ?? "",
      orderType: params.orderType ?? query.orderType ?? "",
      s: params.s ?? query.s ?? "",
      page: params.page ?? query.page ?? 1,
      pageSize: params.pageSize ?? query.pageSize ?? 20,
    };
    let q = helper.arrayToQueryString(fullParams);
    setSearchParams(fullParams);
    history.push({
      pathname: "/orders",
      search: `?${q}`,
      state: fullParams,
    });
  };

  const fetchOrders = async (query) => {
    setLoading(true); //@TODO
    //get users data via API
    await OrderApi.getAllOrders(query)
      .then((res) => {
        setCount(res.length);
        setOrders(res);
        setLoading(false); //@TODO
      })
      .catch((e) => {
      });
  };

  const handlePageChange = (page) => {
    // Always include all filter fields
    loadPage({
      status: query.status,
      orderType: query.orderType,
      page,
      pageSize,
    });
  };


  // Unified filter handler for new Filter component
  const filterHandle = (data) => {
    loadPage({
      ...defaultFilter,
      ...data,
      page: 1,
      pageSize,
    });
  };

  // handling filter reset function
  const handleReset = () => {
    setQuery(initialQuery);
    loadPage(initialQuery);
  };

  useEffect(() => {
    async function fetchData() {
      // Build query from all filter fields
      const newQuery = {
        ...defaultFilter,
        ...Object.fromEntries([...searchParams]),
        page: searchParams.get("page") || 1,
        pageSize: searchParams.get("pageSize") || pageSize,
      };
      setCurrentPage(Number(newQuery.page));
      setQuery(newQuery);
      await fetchOrders(qs.stringify(newQuery));
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <AuthLayout>
      <header
        className={"d-flex justify-content-between align-items-center mb-4"}
      >
        <h2 className="fs-5">{"Orders"}</h2>
        <div className="d-flex align-items-center gap-2">
          <Link className="btn btn-primary" to="/orders/new">
            <i className="bi bi-plus-lg me-1"></i> Create
          </Link>
          <div className="dropdown">
            <button
              className="btn btn-outline-primary dropdown-toggle"
              type="button"
              id="orderActionDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="bi bi-check2 me-1"></i> Action
            </button>
            <ul className="dropdown-menu" aria-labelledby="orderActionDropdown">
              <li><button className="dropdown-item" type="button">Bulk Approve</button></li>
              <li><button className="dropdown-item" type="button">Bulk Delete</button></li>
              <li><hr className="dropdown-divider" /></li>
              <li><button className="dropdown-item" type="button">Export Selected</button></li>
            </ul>
          </div>
        </div>
      </header>

      <Filter
        defaultFilter={defaultFilter}
        filters={filters}
        filterHandle={filterHandle}
        reset={handleReset}
      />
      {loading ? (
        <p className="text-center">Loading...</p>
      ) : orders.length > 0 ? (
        <>
          <Table responsive className="table table-striped mb-4">
            <thead>
              <tr className="text-capitalize">
                <th scope="col" className="fw-normal text-muted text-center">
                  <input
                    type="checkbox"
                    checked={orders.length > 0 && selectedOrders.length === orders.length}
                    onChange={handleSelectAll}
                    aria-label="Select all orders"
                  />
                </th>
                <th scope="col" className="fw-normal text-muted text-center">Type</th>
                <th scope="col" className="fw-normal text-muted">email</th>
                <th scope="col" className="fw-normal text-muted">Item</th>
                <th scope="col" className="fw-normal text-muted">total</th>
                <th scope="col" className="fw-normal text-muted">date</th>
                <th scope="col" className="fw-normal text-muted">payment status</th>
                <th scope="col" className="fw-normal text-muted">order status</th>
                <th scope="col" className="fw-normal text-muted">Action</th>
              </tr>
            </thead>
            <tbody className="border-top-0">
              {orders.map((item, index) => (
                <tr key={index} className="align-middle text-center">
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedOrders.includes(item._id)}
                      onChange={() => handleCheckboxChange(item._id)}
                      aria-label={`Select order ${item._id}`}
                    />
                  </td>
                  <td>
                    {item.orderType === 'single' ? (
                      <i className="bi bi-bag text-muted fs-4" title="Single Order"></i>
                    ) : (
                      <i className="bi bi-bag-plus text-muted fs-4" title="Subscription"></i>
                    )}
                  </td>
                  <td>
                    <Link to={`/orders/view/${item._id}`}>{item.email}</Link>
                  </td>
                  <td>
                    {item.itemId ? (
                      <Link to={`/resources/view/${item.itemId }`}>
                        <span className="text-muted small">
                          {item.itemId }  
                        </span>
                      </Link>
                    ) : (
                      <span className="text-muted small">No Item</span>
                    )}
                  </td>
                  <td>{format.formatCurrency(item.total)}</td>
                  <td className="text-muted small">
                    <span>
                      {dayjs(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                    </span>
                  </td>
                  <td>{format.formatPaymentStatus(item.paymentStatus)}</td>
                  <td>{format.formatOrderStatus(item.orderStatus.status)}</td>
                  <td>
                    <div className="button-group">
                      <Link
                        to={`/orders/view/${item._id}`}
                        className="btn btn-sm"
                      >
                        <i className="bi bi-eye text-muted"></i>
                      </Link>
                      <Link
                        to={`/orders/edit/${item._id}`}
                        className="btn btn-sm"
                      >
                        <i className="bi bi-pencil text-muted"></i>
                      </Link>
                      {/* <Link
                        to={`/oders/delete/${index}`}
                        className="btn btn-sm"
                      >
                       
                        <i className="bi bi-trash-fill text-muted"></i>
                      </Link> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            count={count}
            currentPage={currentPage}
            pageSize={pageSize}
            path={"orders"}
            moduleName={"orders"}
            handlePageChange={handlePageChange}
          />
        </>
      ) : (
        <p>{"Not found"}</p>
      )}
    </AuthLayout>
  );
};

function mapStateToProps(state) {
  const { token } = state.auth;
  const { user } = state.user;
  return {
    token,
    user,
  };
}

export default connect(mapStateToProps)(OrderList);
